import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { signupSteps, loginSteps } from '../../routes/authSteps';
import { motion } from 'framer-motion';
import styles from './AuthProgressBar.module.css';

const AuthProgressBar = () => {
  const location = useLocation();
  const isLoginFlow = location.pathname.startsWith('/login');
  const steps = isLoginFlow ? loginSteps : signupSteps;

  const currentStepIndex = steps.findIndex(step => location.pathname === step.path);
  const [activeStepIndex, setActiveStepIndex] = useState(currentStepIndex);

  useEffect(() => {
    if (currentStepIndex !== activeStepIndex) {
      const timer = setTimeout(() => {
        setActiveStepIndex(currentStepIndex);
      }, 500); // Delay matches line fill duration
      return () => clearTimeout(timer);
    }
  }, [currentStepIndex, activeStepIndex]);

  return (
    <div className={styles.progressWrapper}>
      {steps.map((step, index) => {
        const isLineFilled = index < currentStepIndex;
        const isDotActive = index <= activeStepIndex;

        return (
          <div key={step.path} className={styles.step}>
            <motion.div
              className={`${styles.circle} ${isDotActive ? styles.active : ''}`}
              initial={{ scale: 1 }}
              animate={{ scale: isDotActive ? 1.1 : 1 }}
              transition={{ duration: 0.3, ease: 'easeInOut' }}
            />
            {index < steps.length - 1 && (
              <div className={styles.lineWrapper}>
                <div className={styles.lineBase} />
                <motion.div
                  className={styles.lineFill}
                  initial={{ width: 0 }}
                  animate={{ width: isLineFilled ? '100%' : '0%' }}
                  transition={{ duration: 0.5, ease: 'easeInOut' }}
                />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default AuthProgressBar;